import { apiClient } from './config';
import secureLocalStorage from 'react-secure-storage';

export const categoriesApi = {
  async getAll(limit = 1000) {
    try {
      const businessNumber = secureLocalStorage.getItem("businessId");

      // Build URL with query parameters
      const url = `/api/v1/ecommerce/get_categories?businessNumber=${businessNumber}&limit=${limit}`;
      const response = await apiClient.get(url);

      // Response structure is { status, response: data } from HttpRequest
      if (response && response.response && response.response.Status === 'Success') {
        // Transform the data to normalize the structure
        const transformedData = response.response.data.map(cat => ({
          id: cat._id,
          categoryName: cat.categoryName,
          categoryCode: cat.categoryCode,
          categoryDescription: cat.categoryDescription,
          thumbnail: cat.thumbnail,
          isFeatured: cat.isFeatured || false,
          subcategories: cat.subCategories && cat.subCategories.length > 0
            ? cat.subCategories.map(sub => ({
                id: sub._id,
                name: sub.categoryName,
                categoryCode: sub.categoryCode,
                thumbnail: sub.thumbnail,
                isFeatured: sub.isFeatured || false
              }))
            : []
        }));

        const result = {
          data: transformedData,
          count: response.response.count,
          totalPages: response.response.totalPages,
          currentPage: response.response.currentPage
        };
        return result;
      }

      return { data: [], count: 0, totalPages: 0, currentPage: 1 };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return { data: [], count: 0, totalPages: 0, currentPage: 1 };
    }
  },

  async getById(categoryId) {
    try {
      const businessNumber = secureLocalStorage.getItem("businessId");
      const response = await apiClient.get(`/api/v1/ecommerce/category/${categoryId}`, {
        params: { businessNumber }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching category:', error);
      return null;
    }
  },

  // Get categories grouped for mega menu display
  async getCategoriesForMenu() {
    try {
      const result = await this.getAll();
      const categories = result.data;

      // Group categories by parent/subcategories
      const parentCategories = categories.filter(cat => !cat.subCategory && !cat.parentCategoryId);
      const subCategories = categories.filter(cat => cat.subCategory || cat.parentCategoryId);

      // Create mega menu structure
      const menuStructure = {};

      parentCategories.forEach(parent => {
        const children = subCategories.filter(sub =>
          sub.parentCategoryId === parent._id ||
          sub.parentCategoryName === parent.categoryName
        );

        menuStructure[parent.categoryName] = [
          {
            name: `All ${parent.categoryName}`,
            slug: parent.categoryCode,
            categoryId: parent._id,
            featured: parent.isFeatured || false
          },
          ...children.map(child => ({
            name: child.categoryName,
            slug: child.categoryCode,
            categoryId: child._id,
            featured: child.isFeatured || false
          }))
        ];
      });

      return menuStructure;
    } catch (error) {
      console.error('Error building menu structure:', error);
      return {};
    }
  }
};
